import React from "react";
import {  useEffect } from "react";
import useSWRInfinite  from "swr/infinite";
import axios from 'axios';
import { list } from "../api/api";
import { ContactTable } from "../components/ContactTable";
import { Upload } from "../components/Upload";
import ExpandableSection from "@cloudscape-design/components/expandable-section";


import { useDangerAlert } from "../hooks/useAlert";
import { presign } from "../api/api";
import {
  Button,
  ContentLayout,
  Link,
  Header,
  BreadcrumbGroup,
  Grid,
  FileUpload,
  FormField,
  Form,
  SpaceBetween,
  Spinner,
  ColumnLayout,
  Container
} from '@cloudscape-design/components';

const config = window.pcaSettings;

function Home({ setAlert }) {
  const fetcher = async (url, startKey, timestampFrom) => {
    //console.log('Fetcher!!!!!')
    //console.log(`Fetcher checking CONFIG ${JSON.stringify(config.opts)}`);
    const opts = {
      count: config.api.pageSize,
    };

    if (timestampFrom) opts.timestampFrom = timestampFrom;
    if (startKey) opts.startKey = startKey;
    if(config.opts!=null && config.opts!={})
    {
        const opts1={}
        for (var key in config.opts) 
        {
          if (config.opts.hasOwnProperty(key)) 
          {
                //console.log(key + " -> " + JSON.stringify(config.opts[key]));
                opts1[key]=`${JSON.stringify(config.opts[key])}`;
          }
        }
        //console.log(`call list with opts1 ${JSON.stringify(opts1)}`);
        localStorage.setItem("fetcherOn","true");
        let cacheListRetrieve = localStorage.getItem('cacheList')!=null && localStorage.getItem('cacheList')!='' ? JSON.parse(localStorage.getItem('cacheList')):null;
        let cacheOpts = cacheListRetrieve!=null ? cacheListRetrieve.opts :null;
        if(JSON.stringify(cacheOpts)==JSON.stringify(opts1))
        {
          console.log(`Theres EXISTING  so will not call API/dynamodb`)
          
          return cacheListRetrieve.result;
        }
        else
        {
          let res = await  list(opts1);
          let cacheList = {opts:opts1,result:res}
          //FRAN 2024 11 24 added this to fix issue stuck please wait while retrieving data
          let freshResult = res.timestampFrom;
          let prevResult = cacheListRetrieve?.result?.timestampFrom;
          console.log(`KEY timestampFrom current ${freshResult} previous ${prevResult}`)
          if(freshResult==prevResult)
          {
              res.timestampFrom = res.timestampFrom +1;
              console.log(`UPDATE current to ${res.timestampFrom} to allow Refresh!`)
          }
          //FRAN 2024 11 24 added this to fix issue stuck please wait while retrieving data
          localStorage.setItem('cacheList',JSON.stringify(cacheList))
          return res;
        }
    }
    else
    {
      let countList = localStorage.getItem('countList')!='' && localStorage.getItem('countList')!='undefined' && localStorage.getItem('countList')!=null ? JSON.parse(localStorage.getItem('countList')) :null;
      
      if(countList!=null && countList!={} && countList!=[])
      {
        console.log(`Theres EXISTING  so will not call API/dynamodb`)
        
        return countList;   
      }
      else
      {
        console.log(`call API/dynamodb with opts ${JSON.stringify(opts)}`)
        localStorage.setItem("fetcherOn","true");
        let res = await list(opts);
        localStorage.setItem('countList',JSON.stringify(res));
        return res;    
      }
    }
  };


  useEffect(() => {
    // callback function to call when event triggers
    const onPageLoad = () => {
      localStorage.removeItem('opts');
      localStorage.removeItem('cacheList')
      localStorage.removeItem('countList');
      localStorage.removeItem('fetcherOn');
      sessionStorage.removeItem('opts');
      sessionStorage.removeItem('cacheList')
      sessionStorage.removeItem('countList');
      sessionStorage.removeItem('fetcherOn');
      //console.log('Status localStorage on PageLoad',localStorage)
      //console.log('page loaded');
      // do something else
    };

    // Check if the page has already loaded
    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);
      // Remove the event listener when component unmounts
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);


  const getKey = (pageIndex, previousPageData) => {
    //console.log('Home getKey')



    if (previousPageData && !previousPageData.StartKey) return null;
    if (pageIndex === 0) {
      //console.log('@@@ GET KEY  pageindex=0, return to list')
      return `/list`;
    }

    const { StartKey, timestampFrom } = previousPageData;
    //console.log(`@@@ GET KEY return to List with startkey ${StartKey} and timestampFrom ${timestampFrom}`)
    return [
      `/list?startKey=${StartKey}&timestampFrom=${timestampFrom}`,
      StartKey,
      timestampFrom,
    ];
  };

  const { data, error, size, setSize } = useSWRInfinite(getKey, fetcher,{ 
    /*initialSize: 1, 
    revalidateFirstPage : false,
      revalidateOnMount: true,
      // dedupingInterval: 5000,
      refreshInterval: 700000,
      refreshWhenHidden: true,
      parallel: true*/
      revalidateIfStale: true,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
      refreshInterval: 100,
      refreshWhenHidden: true,

  });
  const [value, setValue] = React.useState([]);

  const isLoadingInitialData = !data && !error;
  const isLoadingMore =
    isLoadingInitialData ||
    (size > 0 && data && typeof data[size - 1] === "undefined");
  const isEmpty = data?.[0]?.length === 0;
  const isReachingEnd =
    isEmpty ||
    (data && data[data.length - 1].Records?.length < config.api.pageSize);

  const details = (data || []).map((d) => d.Records).flat();
  useDangerAlert(error, setAlert);

  return (
    <>
      <ContentLayout 
        header={
            <Header
              variant="h1"
              description="Select a call record to view details."
              info={<Link variant="info" ariaLabel="Info goes here.">Info</Link>}>
              Call List
            </Header>
        }>
        <Container>
          <Grid
            gridDefinition={[
              {colspan: { default:12} },
              {colspan: { default:12} },
              {colspan: { default:12} }
            ]}
          >

            <ContactTable
              data={details}
              loading={!data && !error}
              empty={<Empty />}
            />

          </Grid>
        </Container>
        
      </ContentLayout>
      </>
  );
}

const Empty = () => (
  <div>
    <h2>No results</h2>
  </div>
);

export async function getKeyExt() 
{

  let previousPageData=null;
  let pageIndex=null;
  if (previousPageData && !previousPageData.StartKey) return null;
  if (pageIndex === 0) {
    //console.log('@@@ GET KEY  pageindex=0, return to list')
    return `/list`;
  }

    
};

export default Home;
